import type { FC } from 'react'
import { useTranslation } from '@/translations/i18n'

export const SubmissionFormHeader: FC = () => {
	const { t } = useTranslation()

	return (
		<header className='border-neutral-300 border-b px-6 py-4'>
			<h1 className='font-medium text-lg text-neutral-900'>
				{t('luxe_submissions:initial_evaluation')}
			</h1>
			<p className='text-neutral-600'>
				{t('luxe_submissions:mm_evaluation')}
			</p>
		</header>
	)
}
